import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { usePickerReducer } from './usePickerReducer';
import { pickerContext } from './pickerContext';
export const PickerContextProvider = ({ mode, children }) => {
    const [state, dispatch] = usePickerReducer();
    const value = useMemo(() => [Object.assign(Object.assign({}, state), { isDark: (mode !== null && mode !== void 0 ? mode : state.theme) === 'dark' }), dispatch], [dispatch, mode, state]);
    return _jsx(pickerContext.Provider, Object.assign({ value: value }, { children: children }));
};
